export default {
    AITS_INSTITUTE_ID: [326],
    ROLES: {
        SUPER_ADMIN_ROLE_CODE: "SA",
        SI_ROLE_CODE: "SI",
        DEO_ROLE_CODE: "DEO",
        SME_ROLE_CODE: "SME",
        ID_ROLE_CODE: "ID",
        ST_ROLE_CODE: "ST",
        PA_ROLE_CODE: "PA",
        TE_ROLE_CODE: "TE",
        CO_ROLE_CODE: "CO",
        EDEO_ROLE_CODE: "EXTDEO",
    },
    ROLES_ID: {
        ID: 5,
        TR: 8,
        ST: 9,
        PA: 10,
        CO: 12,
        OR: 11,
        ED: 14,
    },
    MODES: {
        MOBILE: "mobile",
        EMAIL: "email",
    },
    TYPES: {
        SILVER: "SILVER",
        GOLD: "GOLD",
        PLATINUM: "PLATINUM",
    },
    QUE_TYPES: {
        ASSERTION_REASON: 6,
        COMPREHENSION: 7,
        INTEGER: 8,
        MATRIX_MATCH: 9,
        MATRIX_MATCH_OPTION: 10,
        MULTIPLE_CORRECT: 11,
        SINGLE_CORRECT: 12,
        SINGLE_CORRECT_SEC2: 22,
        SUBJECTIVE: 13,
        COMPREHENSION_2Q_SA: 14,
        COMPREHENSION_2Q_MA: 15,
        COMPREHENSION_3Q_SA: 16,
        COMPREHENSION_3Q_MA: 17,
        TC: 19,
        TC_2Q_SA: 20,
        TC_3Q_SA: 21,
		SINGLE_CORRECT_SEC2: 22,
        COMPREHENSION_2Q_MM: 23,
        COMPREHENSION_2Q_NU: 24,
        SUBJECTIVEINTEGER: 25,

    },
    QUESTION_STATUS: {
        INITIAL: 0,
        VISITED: 1,
        ANSWER_SELECTED: 2,
        ANSWER_SELECTED_SAVED: 3,
        ANSWER_NOT_SELECTED_SAVED: 4,
        ANSWER_NOT_SELECTED_REVIEW: 5,
        ANSWER_SELECTED_REVIEW: 6,
    },
    QUESTION_STATUS_COLOR: {
        INITIAL: "grey",
        VISITED: "red",
        ANSWER_SELECTED: "red",
        ANSWER_SELECTED_SAVED: "green",
        ANSWER_NOT_SELECTED_SAVED: "red",
        ANSWER_NOT_SELECTED_REVIEW: "yellow",
        ANSWER_SELECTED_REVIEW: "green",
        CURRENT_QUESTION: "red",
    },
    OPTIONS_ABC: ["A", "B", "C", "D", "E", "F"],
    OPTIONS_PQR: ["P", "Q", "R", "S", "T", "U"],
    TEST_TYPE: {
        COMPLIMENTARY: 1,
        ALL_INDIA_TEST: 2,
        PREVIOUS_YEAR: 3,
        CUSTOM: 4,
		MYT:5,
        PRACTICE_SESSION: 6,
		IMPROVEMEN_ASSIGNMENT:7,
        PAST_TEST: 8,

    },
    TEST_SUB_TYPES: {
        COMPLIMENTARY: 1,
        ALL_INDIA_TEST: 2,
		MYT:21,
    },
    QUESTION_ACTIONS: {
        TEST_STARTED: "TEST_STARTED",
        FIRST_QUESTION: "FIRST_QUESTION",
        LAST_QUESTION: "LAST_QUESTION",
        JUMP: "JUMP",
        SUBMIT: "SUBMIT",
        REVIEW_LATER: "REVIEW_LATER",
        FINISH_TEST: "FINISH_TEST",
        END_TEST: "END_TEST",
        START_SESSION: "START_SESSION",
        CLEAR: "CLEAR",
        NEXT: "NEXT",
        NEXT_QUESTION: "NEXT_QUESTION",
        ANSWER_REVIEW_LATER: "ANSWER_REVIEW_LATER",
        FINISH_TEST_ERROR: "FINISH_TEST_ERROR",
    },
    QUESTION_ACTIVITY: {
        START: "START",
        STOP: "STOP",
    },
    QUESTION_ENTITY: {
        QUESTION: "QUESTION",
        TEST: "TEST",
    },
    PAST_QUESTION_STATUS: {
        NOT_ATTEMPTED: 0,
        CORRECT: 1,
        INCORRECT: 2,
        PARTIALLY_CORRECT: 3,
    },
    PAST_QUESTION_COLOR: {
        NOT_ATTEMPTED: "grey",
        CORRECT: "green",
        INCORRECT: "red",
        PARTIALLY_CORRECT: "blue",
    },
    HEART_BEAT_TIME: 10 * 1000,
    STUDENT_HEALTH_PERCENTAGE_COLOR: {
        GREEN: "#96EA96",
        ORANGE: "#ffbc80",
        RED: "#FF7373",
    },
    TESTWISEANALYSIS_TEST_TYPES: {
        TIMEMACHINE: "timemachine",
        COMPARESCORE: "comparescore",
        NEGATIVEMARKING: "negativemarking",
        CHAPTERWISEPERFORMANCE: "chapterwise",
    },
    DUMMYTEXT: "<p>DUMMY TEXT</p>\n",
    ERROR_CODES: {
        TIMEOUTERROR: "ERR084",
        TESTNOTACTIVE: "ERR073",
    },
    USER_ATTEMPT_STATUS: {
        NA: "NA",
        IC: "IC",
        PC: "PC",
        C: "C",
    },


    USER_ATTEMPT_STATUS_ARRAY:[ {
        id: 1,
        title: "Unattempted",
        code: "NA",
       
    },
    {  id: 2,
        title:"Incorrect",
        code: "IC",
      
    },
    {  id: 3,
        title: "Partially Correct",
        code:  "PC",
    },
    {  id: 4,
        title: "Correct",
        code:  "C",
    },
],
    BONUS_MESSAGE: "You have been awarded bonus marks for this question.",
    UNSUPPROTED_BROWSERS: ["vivobrowser", "uc", "miui","edge-chromium"],
    CUSTOM_DOMAINS: ["altitudeclasses.", "alti19.", "anita.","online.","zerokelvin.",'zerokelvineducation.'],
    CUSTOM_DOMAIN_IDS:{
        ALTITUDE: 28,
        ZEROKELVIN:140
    },
    PAGE_TITLE:{
        28: "Altitude Online Testing & Analysis Platform",
        140:"Zero Kelvin"
    },
    DEFAULT_TITLE: "Eduracle - ",
    DEFAULT_TITLE_TESTING: "Testing Platform - ",
    // YOUTUBE_SEARCH_API_KEY: "AIzaSyCGCE-ykAOzmZtO-J5VU56aKcGKuIQIsP4",
    TEST_NAME_PRACTICE_SESSION: "PS1",
    TEST_SUB_TYPE_PRACTICE_SESSION:22,
    TEST_TYPE_PRACTICE_SESSION:6,
    YOUTUBE_SEARCH_API_KEY: "AIzaSyDw9s5ybRa-AFqeKdgqUV3wZYlXYe8Yw-g",
	CUSTOM_DOMAIN_ID:[28,140],
    BOOSTUP_PRODUCT_ID_FREE_TRIAL: 10,
    BOOSTUP_PRODUCT_ID_FREE_TRIAL_EXPIRY: 30,
    DIFFICULTY_LEVELS: [
        {
            id: 1,
            title: "Easy",
            text: "Easy",
            value: {
                id: 1,
                title: "Easy",
            },
          percentage: 52
        },
        {
            id: 2,
            title: "Moderate",
            text: "Moderate",
            value: {
                id: 2,
                title: "Moderate",
            },
          percentage: 40
        },
        {
            id: 3,
            title: "Tough",
            text: "Tough",
            value: {
                id: 3,
                title: "Tough",
            },
          percentage: 8
        },
    ],
    QUESTION_TYPES_PS: [
        {
            id: 1,
            title: "Single Correct",
            value: [12],
        },
        {
            id: 2,
            title: "Single Correct & Numerical",
            value: [12,13]
        },
        {
            id: 3,
            title: "All Types",
            value: [6,8,9,10,11,12,13,22],
        },
    ],
    TEST_TYPES_IT: [
        {
            id: 1,
            title: "Selfmade",
            value: 1,
        },
        {
            id: 2,
            title: "Readymade",
            value: 2
        },
        {
            id: 3,
            title: "Scheduled",
            value: 3,
        },
    ],
    TEST_TYPES_TR: [
        {
            id: 1,
            title: "Selfmade",
            value: 1,
        },
        {
            id: 2,
            title: "Readymade",
            value: 2
        },
        {
            id: 3,
            title: "Institute Tests",
            value: 3,
        },
    ],
    TEST_TYPES_AQ: [
        {
            id: 2,
            title: "Institute Tests",
            value: 2,
        },
        {
            id: 3,
            title: "Selfmade Tests",
            value: 3,
        },
        {
            id: 1,
            title: "Ready-made Tests",
            value: 1,
        },
        {
            id: 4,
            title: "Practice Session",
            value: 4,
        },
    ],
    TEST_TYPES_BQ: [
        {
            id: 1,
            title: "Ready-made Tests",
            value: 1,
        },
        {
            id: 3,
            title: "Selfmade Tests",
            value: 3,
        },
        {
            id: 4,
            title: "Practice Session",
            value: 4,
        },
        {
            id: 2,
            title: "Institute Tests",
            value: 2,
        },
    ],
	CUSTOM_TEST_STATUS : {
		CREATED : 1,
		IN_PROGRESS : 2,
		FAILED : 3
	  },
	  LICENSE_PURCHASED_TYPE:{
		  RENEW:'renew',
		  ADD:'add'
	  },
	  PRODUCT_IDS_FOR_PURCHASE:[9],
	  INSTITUTE_EXPIRED_ROUTES:["subscription-details",'manage-users'],
      EXCLUDE_LOGO:53,
      UPGRADE_VIDEO_LINK:'https://catv2-test-sol-videos.s3.ap-south-1.amazonaws.com/Upgrade+Page+Video+for+Students+and+Parents.mp4',
      EVENT:{
          CREATE_PRACTICE_SESSION: 'create-practice-session',
      },
      DATE_FORMATS : {
          DISPLAY_DATE : "DD-MM-YYYY",
          DISPLAY_TIME : "HH:mm:ss"
      },
      QUESTIONS_LIMIT :{
        5:100,
        140:100,
        142:100,
        "144b":100,
        "144z":100
    },
    ONLINE_INSTITUTE_ID: 37,
    ONLINE_WEBSITE_REDIRECTION_URL : 'https://newweb.dev.eduracle.com/',
    COOKIE_PATH: '/',
    COOKEI_DOMAIN: '.eduracle.com',
    HIDE_MENU_FOR_ALTITUDE:{
        ST:["ST-BOOST-UP",'TEST-REPORT', "PRACTICE-REPORT",'READY-MADE-TEST', "ATTEMPTED QUESTIONS",  "ST-UPGRADE"],
        PA:['TEST-REPORT', "PRACTICE-REPORT",  "PA-UPGRADE","ST-TEST"]
        
    },
    BIOLOGY_SUBSUBJECTS:[
        {
            id: 1,
            title:"Zoology",
            parent_id: 144,
            code: 'z'
        },
        {
            id: 2,
            title:"Botany",
            parent_id: 144,
            code:'b'

        }
    ],
    BIOLOGY_SUBJECT_ID: 144,
    TARGET_EXAM:['JEE','NEET'],
    CUSTOM_INSTITUTE_ID:[146],
    LONG_TEST_INSTITUTE_IDS:[140,2],
    MOBILE_MAX_WIDTH:991,
    TELEGRAM_SERVICE_HIDE_INSTITUTE_IDS:[140],
    WINDOW_COMPLETION_VALUE:'window_completion',
    ONLINE_TEST_TAB:'Online',
    ROLE_WISE_ROUTE: { 
        IA: ['home','preview-test','instructions-about-test','payment-terms-and-conditions','terms-and-conditions','privacy-policy','result-anaylysis-preview-test','response-analysis-coordinator','response-analysis-director','image', 'question-details'], 
        ST: ['home','past-test','test','exam-summary','terms-and-conditions','payment-terms-and-conditions','bookmarked-question-details','practice-session-question-view','improvement-assignment-question-view','preview-test','instructions-about-test','privacy-policy','result-anaylysis-preview-test','response-analysis-coordinator','response-analysis-director','past-test-details'],
        STC: ['home','past-test','test','preview-test','terms-and-conditions','payment-terms-and-conditions','exam-summary','instructions-about-test','privacy-policy','result-anaylysis-preview-test','response-analysis-coordinator','response-analysis-director','past-test-details'],
        PA: ['home','payment-terms-and-conditions','terms-and-conditions','privacy-policy','result-anaylysis-preview-test','response-analysis-coordinator','response-analysis-director'],
        TE: ['home','past-tests-preview','instructions-about-test','preview-test','payment-terms-and-conditions','terms-and-conditions','privacy-policy','result-anaylysis-preview-test', 'question-details'],
        DEO: ['home','instructions-about-test','preview-test','payment-terms-and-conditions','terms-and-conditions','image', 'question-details']
    },
    FAVICON:{
        28: "faviconaltitude.ico",
        140:"faviconzerokelvin.ico"
    },
    OMR_SUPPORTED_FILE_TYPES:  ['image/jpeg','image/png'],
    institute_ids: process.env.VUE_APP_INSTITUTE_IDS,

    TEMP_PRODUCTION_DEPLOYMENT_TESTING_MESSAGE:1,
    DOWNLOAD_STATUS:{
        IN_PROGRESS:"I",
        COMPLETED:"C",
        
    },
    DOWNLOAD_TYPES: {
        TEST_PAPER: "Test Paper",
        SOLUTION_PAPER:"Solution Paper",
        OMR: "OMR",
        TEST_REPORT: "Test Report",
        PRACTICE_REPORT: "Practice Report"
      },
    DIFFICULTY_PERCENTAGE : {
        1:{
            easy: 50,
            moderate:30 ,
            tough: 20,
        },
        2: {
            easy: 30,
            moderate:50 ,
            tough: 20,
        },
        3: {
            
            easy: 30,
            moderate:20 ,
            tough: 50,
        }

    },
    DOWNLOAD_STATUS:{
        IN_PROGRESS:"I",
        COMPLETED:"C",
        
    },
    DOWNLOAD_TYPES: {
        TEST_PAPER: "Test Paper",
        SOLUTION_PAPER:"Solution Paper",
        OMR: "OMR",
        TEST_REPORT: "Test Report",
        PRACTICE_REPORT: "Practice Report"
      }
};
